<!-- 제목 -->
<svelte:head>
  <title>🐈‍⬛황금메쥬</title>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="robots" content="noindex nofollow" />
  <html lang="en" />

  <!-- fonts -->
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=Gowun+Dodum&family=Hahmlet:wght@100;200;300;400;500&display=swap"
    rel="stylesheet"
  />

  <style>
    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-1Thin.woff')
        format('woff');
      font-weight: 100;
      font-style: normal;
    }

    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-2ExtraLight.woff')
        format('woff');
      font-weight: 200;
      font-style: normal;
    }
    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-3Light.woff')
        format('woff');
      font-weight: 300;
      font-style: normal;
    }
    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-4Regular.woff')
        format('woff');
      font-weight: 400;
      font-style: normal;
    }
    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-5Medium.woff')
        format('woff');
      font-weight: 500;
      font-style: normal;
    }
    @font-face {
      font-family: 'S-CoreDream';
      src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-7ExtraBold.woff')
        format('woff');
      font-weight: 700;
      font-style: normal;
    }
  </style>
</svelte:head>
